import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import BookingService from "../../../../services/reservations/BookingService";

export const REQUEST_FETCH_BOOKING_ATTACHED = "REQUEST_FETCH_BOOKING_ATTACHED";
export const FETCH_BOOKING_ATTACHED_SUCCESS = "FETCH_BOOKING_ATTACHED_SUCCESS";
export const FETCH_BOOKING_ATTACHED_ERROR = "FETCH_BOOKING_ATTACHED_ERROR";

function requestFetchBookingAttached() {
  return {
    type: REQUEST_FETCH_BOOKING_ATTACHED,
  };
}

function fetchBookingAttachedSuccess(json) {
  return {
    type: FETCH_BOOKING_ATTACHED_SUCCESS,
    booking: json.data,
  };
}

function fetchBookingAttachedError(json) {
  return {
    type: FETCH_BOOKING_ATTACHED_ERROR,
    error: json.data,
  };
}


export function findBookingPartner(reservation_id, cabin_id) {
  return (dispatch) => {
    dispatch(requestFetchBookingAttached());
    return BookingService.findBookingPartner(reservation_id, cabin_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(fetchBookingAttachedSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(findBookingPartner(reservation_id, cabin_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchBookingAttachedError(json.data));
      }
    });
  };
}
